import { Store } from "@bryntum/schedulerpro";
import { FieldAdvisorCard } from "../models/FieldAdvisorCard";
import { STORE_KEYS } from "../../other/constants/StoreKeys.jsx";
import { SwivuConnectedStoreMixin } from "./mixins/SwivuConnectedStoreMixin";

export class SwivuFieldAdvisorCardStore extends SwivuConnectedStoreMixin(Store) {
  static get $name() {
    return "SwivuFieldAdvisorCardStore";
  }

  static get configurable() {
    return {
      id: STORE_KEYS.fieldAdvisorCardsStore,
      storeId: STORE_KEYS.fieldAdvisorCardsStore,
      modelClass: FieldAdvisorCard,
    };
  }
}
